import { supabase } from '@/lib/supabaseClient'

export async function configureDiscountRules(projectId, rules) {
  const { data, error } = await supabase.rpc('configure_project_discount_rules', {
    p_project_id: projectId,
    p_max_discount_percent: rules.maxDiscountPercent,
    p_min_discount_percent: rules.minDiscountPercent,
    p_discounted_presales_count: rules.discountedPresalesCount,
    p_continue_at_minimum: rules.continueAtMinimum ?? true,
    p_allow_furniture_packages: rules.allowFurniturePackages ?? false,
  })

  if (error) throw error
  return { data }
}

export async function getDiscountRules(projectId) {
  const { data, error } = await supabase
    .from('project_discount_rules')
    .select('*')
    .eq('project_id', projectId)
    .maybeSingle()

  if (error) throw error
  return { data }
}

export async function getCurrentDiscount(projectId) {
  const { data, error } = await supabase.rpc('get_current_discount_for_project', {
    p_project_id: projectId,
  })

  if (error) throw error
  return { data: data?.[0] || null }
}

export async function getDiscountSlots(projectId) {
  const { data, error } = await supabase
    .from('discount_slots')
    .select('*')
    .eq('project_id', projectId)
    .order('slot_number')

  if (error) throw error
  return { data }
}

export async function getReservationDiscount(reservationId) {
  const { data, error } = await supabase
    .from('reservation_discounts')
    .select(`
      *,
      discount_slot:discount_slots(*),
      allocation:discount_allocations(*)
    `)
    .eq('reservation_id', reservationId)
    .maybeSingle()

  if (error) throw error
  return { data }
}

export async function updateDiscountAllocation(reservationDiscountId, allocation) {
  const { data, error } = await supabase.rpc('update_discount_allocation', {
    p_reservation_discount_id: reservationDiscountId,
    p_deposit_contribution: allocation.depositContribution || 0,
    p_price_reduction: allocation.priceReduction || 0,
    p_furniture_packages: allocation.furniturePackages || 0,
  })

  if (error) throw error
  return { data }
}

export async function setUnitDiscountEligibility(unitId, isEligible, exclusionReason = null) {
  const { data, error } = await supabase
    .from('unit_discount_eligibility')
    .upsert({
      unit_id: unitId,
      is_eligible: isEligible,
      exclusion_reason: exclusionReason,
    }, {
      onConflict: 'unit_id'
    })
    .select()
    .single()

  if (error) throw error
  return { data }
}

export async function getUnitEligibility(unitId) {
  const { data, error } = await supabase
    .from('unit_discount_eligibility')
    .select('*')
    .eq('unit_id', unitId)
    .maybeSingle()

  if (error) throw error
  return { data }
}

export async function toggleDiscountRulesActive(projectId, isActive) {
  const { data, error } = await supabase
    .from('project_discount_rules')
    .update({ is_active: isActive, updated_at: new Date().toISOString() })
    .eq('project_id', projectId)
    .select()
    .single()

  if (error) throw error
  return { data }
}
